import useSessionMerchantUser from './useSessionMerchantUser'

const useIsWegoMerchantUser = () => {
  const {merchantUser} = useSessionMerchantUser()
  return merchantUser?.merchant.name.startsWith('Wego ')
}

export default useIsWegoMerchantUser
